import {useQuery} from "react-query";
import {alertApi} from "../api/alert-api";
import {setAlertAction} from "../app/reducers/alert-slice";
import {store} from "../app/store";
import {convertOperationAlert} from "../utils/converter/alert/operation-alert-converter";

export enum AlertQueryKey {
  GetAll = "GetAllAlert",
}

export const useGetAllAlertQuery = (
    isEmptyAgencies: boolean,
) => {
  return useQuery([AlertQueryKey.GetAll], () => alertApi.getAll(), {
    enabled: isEmptyAgencies,
    refetchInterval: 1000 * 60,
    onSuccess: ({ data }) => {
      const alerts = convertOperationAlert(data);
      store.dispatch(
        setAlertAction({
          ...alerts,
        })
      );
    },
  });
};
